import { inAppChatService } from '@egw/app-chat'
import { Button, ButtonVariant } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'

export const ClientServicesLink: FC<{ onClickCb?: () => void }> = ({ onClickCb }) => {
  const { t } = useTranslation('features-transfer')

  const clientServicesOnClick = (): void => {
    inAppChatService.open()
    onClickCb && onClickCb()
  }

  return (
    <Button
      size="small"
      onClick={clientServicesOnClick}
      data-testid="transferErrorContactClientServices"
      variant={ButtonVariant.Secondary}
    >
      {t('client-services.contact_client_services')}
    </Button>
  )
}
